<template>
    <div class="famous-pedia-create-pedia">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <div class="famous-pedia-fate-topbar">
            <!-- 1. 顶部菜单栏 -->
            <famous-title-bar
                v-if="!fromEmbedded"
                v-bind:fromPage="pageName"
                v-bind:titleName="curPediaBaziInfo.f_name">
            </famous-title-bar>

            <!-- 2. 迷你命盘+运盘组件 -->
            <mini-fate-fortune-panel
                v-bind:fromPage="pageName"
                v-bind:fortuneItemFunc="changeFateSideListData"
                v-bind:fateSideCloseFunc="changeFateSideListData">
            </mini-fate-fortune-panel>
        </div>
        <!-- 主要内容部分 -->
        <famous-form></famous-form>
    </div>
</template>
<script>
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import FamousTitleBar from '../../layouts/famouspedia/FamousTitleBar.vue'
import FamousForm from '../../layouts/famouspedia/FamousForm.vue'
import { FAMOUS_DOM } from '../../modules/dom'
export default {
    name: 'FamousPediaEdit',
    components: { MiniFateFortunePanel, FamousTitleBar, FamousForm },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        gotCurrentPediaData() {
            return this.$store.state.famouspedia.gotCurrentPediaData
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo
        }
    },
    data() {
        return {
            pageName: 'FamousPediaEdit',
            hideName: true
        }
    },
    created() {
        if(!this.gotCurrentPediaData && !this.fromEmbedded) {
            this.$router.replace('/famouspediacreate');
        }
    },
    methods: {
        // 迷你命盘运盘的数据与大运流年数据的联动
        changeFateSideListData(data, fateSideListData) {
            console.log('changeFateSideListData-------', data, fateSideListData)
            if(fateSideListData.length == 0) {
                this.$store.state.comment.curActiveName = '';
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousEditFormScrollTop('');
                }, 300);
            }
            if(data.type == 'dayun' || data.type == 'liunian') {
                this.$store.dispatch('comment/updateCommentActiveNames', {
                    listData: fateSideListData,
                    cb: function(curName) {
                        FAMOUS_DOM.updateFamousEditFormScrollTop(curName);
                    }
                });
            }
        },
    }
}
</script>